import { Helmet } from 'react-helmet';
import { siteConfig } from '../config.js';
import SectionA from '../components/ServicesSectionA.js';
import SectionB from '../components/ServicesSectionB.js';
import SectionC from '../components/ServicesSectionC.js';
import SectionD from '../components/ServicesSectionD.js';
import JoinOurCommunity from '../components/JoinOurCommunity.js';
import Header from '../components/Header.js';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';

export default function ServicePage() {
  return (
    <>
      <Helmet>
        <title>Services | {siteConfig.title}</title>
        <meta name="description" content={siteConfig.metaDescription} />
      </Helmet>

      <Header config={siteConfig} />
        <SectionA />  
        <SectionB />  
        <SectionC />  
        <SectionD />
        <JoinOurCommunity />
      <PreFooter />
      <Footer />
    </>
  );
}
